import { createContext, useContext } from 'react';

export const AvailableToBillSearchContext = createContext();

export const useAvailableToBillSearchContext = () =>
  useContext(AvailableToBillSearchContext);

export default AvailableToBillSearchContext;
